import * as React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import {logger} from '../utils';


export default function waitTimer(flag) {

        const [loading, setLoading] = React.useState(false);
        const [query, setQuery] = React.useState(false);
        const timerRef = React.useRef ();


        React.useEffect(
            () => () => {
                clearTimeout(timerRef.current);
            },
            [],
        );

        const test1 = () => {
            setLoading((prevLoading) => !prevLoading);
        };

        const test2 = () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }

            if (!query) {
                setQuery(false);
                return;
            }

            setQuery(true);
            timerRef.current = window.setTimeout(() => {
                setQuery(true);
            }, 2000);
        };

        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Box sx={{ height: 40 }}>
                    <Fade
                        in={loading}
                        style={{
                            transitionDelay: loading ? '800ms' : '0ms',
                        }}
                        unmountOnExit
                    >
                        <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row" justifyContent="center">
                            <CircularProgress color="secondary" />
                            <CircularProgress color="success" />
                            <CircularProgress color="inherit" />
                        </Stack>
                    </Fade>
                </Box>
                <Box>
             <Button onClick={test1} sx={{ m: 2 }}>
        {(!query) ? 'Reset' : 'Simulate a load'}
      </Button>
    </Box >
            </Box>
        );
    

    
}